export class Formattable<T> {
  public constructor(private value: unknown) {}

  private _nullReplacer(_: string, value: unknown) {
    if (value !== null) return value;
  }

  text() {
    try {
      // can throw a parse exception
      // because the value may not be a valid JSON string
      return JSON.stringify(JSON.parse(this.value as string), this._nullReplacer);
    } catch (error) {
      // by default
      // return a string converted representation of the value
      return this.value?.toString();
    }
  }

  json(): T {
    return JSON.parse(JSON.stringify(this.value || "{}"), this._nullReplacer) as T;
  }
}
